<template>
        <b-modal id="delete-irreversibly" centered size="lg" hide-footer hide-header>
            <template #default>
                <div class="d-flex flex-column p-4">
                    <div class="d-flex flex-column justify-content-center align-items-center mb-4 pb-3 border-bottom">
                        <b-icon icon="exclamation-triangle" variant="danger" class="h1"/>
                        <span class="h1 text-danger">Безвозвратное удаление</span>
                    </div>
                    <div class="d-flex flex-column align-items-center mb-5">
                        <span class="h4 mb-3">Вы собираетесь насовсем удалить {{ rows.length }} <slot name="genitiveObjectName"></slot>.</span>
                        <span>Это действие нельзя отменить. </span>
                        <slot name="linkedObjectsText"></slot>
                    </div>
                    <div class="d-flex justify-content-center">
                        <b-button variant="info" class="mr-3" @click="$bvModal.hide('delete-irreversibly')"><span>Отмена</span></b-button>
                        <b-button variant="danger" class="d-flex align-items-center" @click="onDeleteIrreversibleClick"><span class="mr-2"><b-icon icon="trash" /></span><span>Удалить</span></b-button>
                    </div>
                </div>
            </template>
        </b-modal>
</template>

<script>
import httpClient from "@/http";

export default {
    name: "DataTableIrreversibleDeleteModal",
    props: {
        url: { type: String },
        // rows: { type: Array, default: () => { return [] } },
    },
    data() {
        return {
            rows: []
        }
    },
    methods: {
        setRows(rows) {
            this.rows = rows
        },
        onDeleteIrreversibleClick() {
            const vm = this;
            httpClient.post(vm.url, { ids: vm.rows })
            .then((response) => {
                vm.$emit('irreversible-delete-success');
                vm.$bvToast.toast('Записи удалены', { title: 'Успешно', variant: 'success'})
                vm.$bvModal.hide('delete-irreversibly')
            }).catch((reason) => {
                vm.$bvToast.toast(reason, { title: 'Не удалось безвозвратно удалить выбранные записи', variant: 'danger'})
            })
        }
    }
}
</script>

<style scoped>

</style>